module.exports = __webpack_public_path__ + "img/161.7051adc7.jpg";